const config = {
  env: "local",
  apiUrl: "https://api.hajisabarmart.com/api/",
 // apiUrl: "http://200.97.162.180:6080/api/",
 // apiUrl: "http://192.168.0.58:5900/api/",  //ip local
};

export default config;
